import { load } from "../../../../pages/player/_id_/_page.server.js";
import "path";
async function GET(event) {
  return new Response(JSON.stringify(await load(event)));
}
export {
  GET
};
